export const DRIVER_CONDITION_ITEMS = [
  { id: 'illness', label: '病気・体調不良' },
  { id: 'fatigue', label: '疲労' },
  { id: 'sleepDeprivation', label: '睡眠不足' },
]

export const VEHICLE_INSPECTION_ITEMS = [
  { id: 'brakes', label: 'ブレーキの踏みしろ・効き' },
  { id: 'parkingBrake', label: 'パーキングブレーキ' },
  { id: 'tires', label: 'タイヤの空気圧・損傷・摩耗' },
  { id: 'lamps', label: '灯火・方向指示器' },
  { id: 'engine', label: 'エンジンのかかり・異音' },
  { id: 'meters', label: '警告灯・各種メーター' },
  { id: 'fluids', label: 'オイル・冷却水・液漏れ' },
  { id: 'wipers', label: 'ワイパー・ウォッシャー' },
]

export function emptySafetyValues(items) {
  return Object.fromEntries(items.map((item) => [item.id, null]))
}

export function completedSafetyValues(items) {
  return Object.fromEntries(items.map((item) => [item.id, 'ok']))
}

export function hasSafetyIssue(check) {
  if (!check) return false
  return [...Object.values(check.driverCondition || {}), ...Object.values(check.vehicleInspection || {})].some((value) => value === 'review')
}

export function safetyStatusLabel(check) {
  if (!check) return '—'
  return hasSafetyIssue(check) || check.status === 'review' ? '要確認' : '良好'
}

export function safetyIssueLabels(check) {
  if (!check) return []
  const labels = []
  DRIVER_CONDITION_ITEMS.forEach((item) => {
    if (check.driverCondition?.[item.id] === 'review') labels.push(item.label)
  })
  VEHICLE_INSPECTION_ITEMS.forEach((item) => {
    if (check.vehicleInspection?.[item.id] === 'review') labels.push(item.label)
  })
  return labels
}
